import { useSyncExternalStore } from 'react';

/*
  Подсказки клавиш по удержанию Alt (DESIGN.md R33).
  Приём характера: интерфейс учит себя сам. Пока Alt не нажат, экран чистый; удержал —
  рядом с действиями проступили их клавиши. Не нужно идти в справку и не нужно засорять
  кнопки подписями на каждый день.

  Слушатель один на всё приложение (внешнее хранилище + useSyncExternalStore), а не по
  слушателю на каждую подсказку. Отпускание Alt и потеря фокуса окном гасят подсказки:
  иначе после переключения окна они зависают навсегда.
*/

let held = false;
const listeners = new Set<() => void>();
let bound = false;

function emit() {
  for (const l of listeners) l();
}

function set(next: boolean) {
  if (held === next) return;
  held = next;
  emit();
}

function bind() {
  if (bound || typeof window === 'undefined') return;
  bound = true;
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Alt') set(true);
  });
  window.addEventListener('keyup', (e) => {
    if (e.key === 'Alt') set(false);
  });
  window.addEventListener('blur', () => set(false));
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) set(false);
  });
}

function subscribe(cb: () => void) {
  bind();
  listeners.add(cb);
  return () => listeners.delete(cb);
}

/** true, пока удерживается Alt. */
export function useAltHeld() {
  return useSyncExternalStore(
    subscribe,
    () => held,
    () => false,
  );
}
